<template>
    <div>
        <b-container fluid class="mt--7">
            <b-row>
                <b-col>
                    <audit-log-table title="Logs" />
                </b-col>
            </b-row>
        </b-container>
    </div>
</template>
<script>
import AuditLogTable from './AuditLogTable'

export default {
    name: 'tables',
    components: {
        AuditLogTable,
    },
    data: () => {
        return {}
    },

    methods: {},
}
</script>
<style></style>
